import React from 'react';
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Box,
    Typography,
    Divider,
    Avatar,
    IconButton,
} from '@mui/material';
import {
    Dashboard,
    Campaign,
    Schedule,
    AccountCircle,
    Message,
    Analytics,
    Description,
    CalendarToday,
    History,
    Payment,
    AdminPanelSettings,
    Logout,
    Close,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';

const MobileDrawer = ({ open, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);

    const menuItems = [
        { text: 'لوحة التحكم', icon: <Dashboard />, path: '/dashboard' },
        { text: 'الحملات', icon: <Campaign />, path: '/campaigns' },
        { text: 'المنشورات المجدولة', icon: <Schedule />, path: '/scheduled' },
        { text: 'الحسابات', icon: <AccountCircle />, path: '/accounts' },
        { text: 'الشات بوت', icon: <Message />, path: '/chatbot' },
        { text: 'التحليلات', icon: <Analytics />, path: '/analytics' },
        { text: 'المسودات', icon: <Description />, path: '/drafts' },
        { text: 'التقويم', icon: <CalendarToday />, path: '/calendar' },
        { text: 'القوالب', icon: <Description />, path: '/templates' },
        { text: 'سجل النشاطات', icon: <History />, path: '/activity-logs' },
    ];

    const handleNavigation = (path) => {
        navigate(path);
        onClose();
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
        onClose();
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            dir="rtl"
            PaperProps={{
                sx: {
                    width: 280,
                    bgcolor: 'background.default',
                },
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    bgcolor: 'primary.main',
                    color: 'white',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar sx={{ bgcolor: 'white', color: 'primary.main' }}>
                        {user?.username?.charAt(0).toUpperCase()}
                    </Avatar>
                    <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {user?.username}
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.9 }}>
                            {user?.subscription?.plan || 'Free'}
                        </Typography>
                    </Box>
                </Box>
                <IconButton onClick={onClose} sx={{ color: 'white' }}>
                    <Close />
                </IconButton>
            </Box>

            <Divider />

            {/* Navigation Items */}
            <List sx={{ pt: 1 }}>
                {(user?.isAdmin ?
                    // Admin gets both menus
                    [
                        { text: 'لوحة الإدارة', icon: <AdminPanelSettings />, path: '/admin' },
                        { text: 'طلبات الدفع', icon: <Payment />, path: '/admin/payments' },
                        ...menuItems
                    ]
                    :
                    // User Menu
                    menuItems
                ).map((item) => (
                    <ListItem key={item.path} disablePadding>
                        <ListItemButton
                            onClick={() => handleNavigation(item.path)}
                            selected={location.pathname === item.path}
                            sx={{
                                borderRadius: 1,
                                mx: 1,
                                my: 0.5,
                                '&.Mui-selected': {
                                    bgcolor: 'primary.light',
                                    color: 'primary.main',
                                    '& .MuiListItemIcon-root': {
                                        color: 'primary.main',
                                    },
                                },
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            <Divider />

            {/* Bottom Actions */}
            <List sx={{ mt: 'auto' }}>
                {/* Show Billing only for Users */}
                {!user?.isAdmin && (
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => handleNavigation('/billing')}
                            sx={{ borderRadius: 1, mx: 1 }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Payment />
                            </ListItemIcon>
                            <ListItemText primary="الفواتير والاشتراك" />
                        </ListItemButton>
                    </ListItem>
                )}

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={handleLogout}
                        sx={{
                            borderRadius: 1,
                            mx: 1,
                            color: 'error.main',
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40, color: 'error.main' }}>
                            <Logout />
                        </ListItemIcon>
                        <ListItemText primary="تسجيل الخروج" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Drawer>
    );
};

export default MobileDrawer;
